import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAdminSubscriptionConfig, upsertAdminSubscriptionConfig } from "../utils/adminApi";

export const ADMIN_SUBSCRIPTION_CONFIG_QUERY_KEY = ["admin", "subscription-config"];

export const useAdminSubscriptionConfig = () => {
  return useQuery({
    queryKey: ADMIN_SUBSCRIPTION_CONFIG_QUERY_KEY,
    queryFn: () => fetchAdminSubscriptionConfig(),
    refetchOnWindowFocus: false,
  });
};

export const useUpsertAdminSubscriptionConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => upsertAdminSubscriptionConfig(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ADMIN_SUBSCRIPTION_CONFIG_QUERY_KEY });
    },
  });
};

